export const detailedCourses = {
  // ELEVARE COURSES
  "full-stack-web-development": {
    images: ["/images/courses/full-stack-web-development-1.webp", "/images/courses/full-stack-web-development-2.webp"],
    bgDesktop: "/images/courses/full-stack-web-development-cd-desktop.webp",
    bgMobile: "/images/courses/full-stack-web-development-cd-mobile.webp",
    title: "Full Stack Web Development",
    category: "Elevare Academy",
    duration: "4 Months",
    mode: "Hybrid (Online Live + Classroom Labs)",
    level: "Beginner to Professional",
    tagline: "Build production-ready web platforms and launch your engineering career.",
    description: "Learn to design, build, and deploy robust, modern web systems. This course covers everything from pixel-perfect responsive layouts to scalable databases, server routing architectures, and web deployment. By the end of this course, you will have completed 4 production-grade projects and a personal portfolio verified by industry mentors.",
    highlights: ["Project Development", "Interview Preparation", "1-on-1 Mentorship", "Live Cloud Deployments"],
    syllabus: [
      { phase: "Phase 1", title: "Frontend Engineering Foundation", desc: "HTML5, CSS3, ES6+ JavaScript, Responsive layout models (Flexbox, Grid), DOM manipulation, and dynamic client-side scripting." },
      { phase: "Phase 2", title: "Modern Frameworks with React", desc: "Single Page Application (SPA) architecture, state hooks, routing pipelines, state management, and Tailwind styling." },
      { phase: "Phase 3", title: "Backend Systems & API Design", desc: "Node.js runtime engines, Express.js frameworks, RESTful API controllers, routing structures, and CORS controllers." },
      { phase: "Phase 4", title: "Data Storage & Integration", desc: "MongoDB schemas, CRUD operations, database querying, validation, and connecting to modern frontends." },
      { phase: "Phase 5", title: "Deployment & Production Scaling", desc: "Environment variables, Git version controls, cloud hosting (Vercel, Render), caching, and optimization." }
    ],
    tools: ["React", "Node.js", "Express", "MongoDB", "Tailwind CSS", "Git/GitHub", "Vercel", "Postman"],
    outcomes: [
      "Architect responsive frontend interfaces that match custom designs perfectly",
      "Build secure, modular backend server engines with structured REST APIs",
      "Deploy live full-stack database systems on production cloud hosting",
      "Conduct professional code reviews and manage repositories with Git workflows"
    ],
    faqs: [
      { question: "Do I need a computer science background?", answer: "No, this program starts from absolute foundations and guides you to professional readiness." },
      { question: "What projects will I build?", answer: "You will build an e-commerce platform, a real-time team collaboration app, and a custom developer portfolio." }
    ],
    requirements: [
      "Basic computer literacy",
      "A personal laptop (Windows/Mac/Linux)",
      "Dedication of 10-12 hours per week for study & practice"
    ],
    reviews: []
  },
  "data-analytics": {
    images: ["/images/courses/data-analytics-1.webp", "/images/courses/data-analytics-2.webp"],
    bgDesktop: "/images/courses/data-analytics-cd-desktop.webp",
    bgMobile: "/images/courses/data-analytics-cd-mobile.webp",
    title: "Data Analytics",
    category: "Elevare Academy",
    duration: "4 Months",
    mode: "Hybrid",
    level: "Beginner to Intermediate",
    tagline: "Transform raw data into strategic business insights.",
    description: "Master database querying, data aggregation, interactive visualization, and statistical reporting tools to make high-impact corporate decisions.",
    highlights: ["Project Development", "Interview Preparation", "SQL Database labs", "Industry case studies"],
    syllabus: [
      { phase: "Phase 1", title: "Advanced Excel Modeling", desc: "Formulas, lookup functions, pivot charts, and complex financial formatting." },
      { phase: "Phase 2", title: "Database Querying with SQL", desc: "Relational database structures, joins, aggregations, and subqueries." },
      { phase: "Phase 3", title: "Visual Dashboards", desc: "Building interactive corporate dashboards with Tableau and PowerBI." },
      { phase: "Phase 4", title: "Introduction to Python Analytics", desc: "Pandas and NumPy for data manipulation and analysis." }
    ],
    tools: ["SQL", "PowerBI", "Tableau", "Excel", "Python", "Pandas"],
    outcomes: [
      "Perform complex relational database queries to extract insights",
      "Build interactive dashboard panels used by corporate executives",
      "Formulate statistical models to forecast growth and revenue parameters"
    ],
    faqs: [
      { question: "Is SQL hard for beginners?", answer: "No, SQL is one of the most intuitive and readable query languages, and we teach it step-by-step." }
    ],
    requirements: [
      "Basic spreadsheet skills (Excel or Google Sheets)",
      "A personal laptop",
      "Strong logical & analytical mindset"
    ],
    reviews: []
  },
  "data-science": {
    images: ["/images/courses/data-science-1.webp", "/images/courses/data-science-2.webp"],
    bgDesktop: "/images/courses/data-science-cd-desktop.webp",
    bgMobile: "/images/courses/data-science-cd-mobile.webp",
    title: "Data Science",
    category: "Elevare Academy",
    duration: "4 Months",
    mode: "Online Live & Hybrid Labs",
    level: "Intermediate to Advanced",
    tagline: "Uncover patterns, build statistical models, and master scientific computations.",
    description: "Bridge the gap between math and technology by learning computational math, probability models, statistics, and computational python script models.",
    highlights: ["Project Development", "Interview Preparation", "Statistical algorithms", "Research case studies"],
    syllabus: [
      { phase: "Phase 1", title: "Probability & Statistics Core", desc: "Hypothesis testing, variance estimation, normal distributions, and probability models." },
      { phase: "Phase 2", title: "Advanced Python Algorithms", desc: "Scientific computation libraries, advanced arrays, and numerical parsing." },
      { phase: "Phase 3", title: "Exploratory Data Analysis (EDA)", desc: "Finding hidden correlation trends, visual plots, and outlier removals." },
      { phase: "Phase 4", title: "Introduction to Machine Learning", desc: "Regression formulas, classification metrics, and predictive modeling." }
    ],
    tools: ["Python", "Jupyter Notebooks", "NumPy", "Pandas", "Scikit-Learn", "Matplotlib"],
    outcomes: [
      "Design scientific data exploration graphs and statistical hypothesis tests",
      "Deploy custom regression models to forecast analytical indicators",
      "Uncover structural correlations in unstructured datasets"
    ],
    faqs: [
      { question: "Is statistics a prerequisite?", answer: "Basic high school math is helpful, but we cover core probability and statistics from scratch." }
    ],
    requirements: [
      "High school level mathematics (basics of algebra & probability)",
      "A personal laptop",
      "Basic logical programming reasoning"
    ],
    reviews: []
  },
  "machine-learning": {
    images: ["/images/courses/machine-learning-1.webp", "/images/courses/machine-learning-2.webp"],
    bgDesktop: "/images/courses/machine-learning-cd-desktop.webp",
    bgMobile: "/images/courses/machine-learning-cd-mobile.webp",
    title: "Machine Learning",
    category: "Elevare Academy",
    duration: "4 Months",
    mode: "Hybrid Labs",
    level: "Advanced",
    tagline: "Build smart algorithms and self-learning neural networks.",
    description: "Dive deep into deep learning, computer vision, natural language processing, and advanced neural architecture parameters.",
    highlights: ["Project Development", "Interview Preparation", "AI pipeline builds", "Neural Networks"],
    syllabus: [
      { phase: "Phase 1", title: "Supervised Learning Models", desc: "Linear/Logistic Regression, Decision Trees, Random Forests, SVM models." },
      { phase: "Phase 2", title: "Unsupervised Clustering", desc: "K-Means clustering, PCA dimension reduction, hierarchical clustering." },
      { phase: "Phase 3", title: "Deep Learning Foundations", desc: "Artificial Neural Networks, backpropagation algorithms, activation functions." },
      { phase: "Phase 4", title: "Computer Vision & NLP Intro", desc: "CNNs for image classification and transformers/RNNs for text analysis." }
    ],
    tools: ["Python", "TensorFlow", "PyTorch", "Scikit-Learn", "Jupyter", "Keras"],
    outcomes: [
      "Train complex neural architectures to classify objects in image grids",
      "Design advanced unsupervised algorithms to discover user segments",
      "Deploy automated ML models on cloud execution pipelines"
    ],
    faqs: [],
    requirements: [
      "Intermediate Python programming knowledge",
      "Familiarity with basic statistics and coordinate math",
      "A personal laptop"
    ],
    reviews: []
  },
  "business-analytics": {
    images: ["/images/courses/business-analytics-1.webp", "/images/courses/business-analytics-2.webp"],
    bgDesktop: "/images/courses/business-analytics-cd-desktop.webp",
    bgMobile: "/images/courses/business-analytics-cd-mobile.webp",
    title: "Business Analytics",
    category: "Elevare Academy",
    duration: "3 Months",
    mode: "Hybrid",
    level: "Intermediate",
    tagline: "Tool-focused, zero-coding business intelligence & decision frameworks.",
    description: "Translate visual charts into strategic frameworks, run A/B marketing experiments, and build predictive models using top business intelligence tools—with zero coding required.",
    highlights: ["Project Development", "Interview Preparation", "A/B Testing scenarios", "ROI analysis frameworks"],
    syllabus: [
      { phase: "Phase 1", title: "Financial Modeling Core", desc: "Budget planning models, cost optimization patterns, and ROI metrics." },
      { phase: "Phase 2", title: "A/B Testing & Optimization", desc: "Hypothesis validation in corporate setups, conversion rate formulas, page layouts testing." },
      { phase: "Phase 3", title: "Predictive Corporate Models", desc: "Evaluating customer lifetime value and churn probability parameters." }
    ],
    tools: ["PowerBI", "SQL Basics", "Excel Solver", "Tableau", "Google Analytics", "No-Code BI Platforms"],
    outcomes: [
      "Validate product changes using advanced statistical A/B test methodologies",
      "Forecast business indicators and ROI values on dashboard modules"
    ],
    faqs: [
      { question: "Do I need programming experience for this course?", answer: "No, this is a tool-focused, zero-coding track. We focus entirely on business intelligence tools like PowerBI, Tableau, Excel, and SQL basics." }
    ],
    requirements: [
      "Basic computer operations",
      "Interest in business strategy & operations",
      "No coding experience required (Pure No-Code Track)"
    ],
    reviews: []
  },

  // ELEVARE FIRST YEAR
  "basics-of-web-development": {
    images: ["/images/courses/basics-of-web-development-1.webp", "/images/courses/basics-of-web-development-2.webp"],
    bgDesktop: "/images/courses/basics-of-web-development-cd-desktop.webp",
    bgMobile: "/images/courses/basics-of-web-development-cd-mobile.webp",
    title: "Basics of Web Development",
    category: "Elevare First Year Program",
    duration: "1 Month",
    mode: "Classroom Labs",
    level: "Absolute Beginner",
    tagline: "Your first step into the world of web engineering.",
    description: "Understand how websites work, write clean HTML, customize layouts with CSS, and add interactive scripts using foundational JavaScript.",
    highlights: ["Project Development", "100% Practical Labs", "Concept checklist"],
    syllabus: [
      { phase: "Phase 1", title: "Semantic HTML5", desc: "Structuring text, forms, media nodes, and learning search optimization layouts." },
      { phase: "Phase 2", title: "Responsive CSS3", desc: "Box models, position values, colors, margins, Flexbox layouts, and grids." },
      { phase: "Phase 3", title: "JavaScript Logic", desc: "Variables, conditions, loops, array controls, and changing website content dynamically." }
    ],
    tools: ["VS Code", "HTML5", "CSS3", "JavaScript", "Google Chrome DevTools"],
    outcomes: [
      "Construct multi-page responsive layouts that look great on smartphones",
      "Implement simple interactive scripts (like modal boxes, calculator apps)",
      "Deploy web pages live online using free hosting platforms"
    ],
    faqs: [],
    reviews: []
  },
  "python-programming": {
    images: ["/images/courses/python-programming-1.webp", "/images/courses/python-programming-2.webp"],
    bgDesktop: "/images/courses/python-programming-cd-desktop.webp",
    bgMobile: "/images/courses/python-programming-cd-mobile.webp",
    title: "Python Programming",
    category: "Elevare First Year Program",
    duration: "1 Month",
    mode: "Classroom Labs",
    level: "Absolute Beginner",
    tagline: "Learn the world's most popular, versatile script syntax.",
    description: "Perfect introduction to computational logic. Learn variables, loops, custom function modules, and file input/output methods.",
    highlights: ["Project Development", "Coding quizzes", "Foundational logic"],
    syllabus: [
      { phase: "Phase 1", title: "Variables & Calculations", desc: "Core syntax structures, print parameters, inputs, and standard data types." },
      { phase: "Phase 2", title: "Control Flows", desc: "If-else conditions, nested logic loops, while execution blocks." },
      { phase: "Phase 3", title: "Data Collections & Modules", desc: "Lists, tuples, dictionaries, custom functions, and importing standard math libraries." }
    ],
    tools: ["Python", "VS Code", "Terminal"],
    outcomes: [
      "Formulate custom logical scripts to solve mathematical word problems",
      "Manipulate dictionary data files and write scripts to save reports",
      "Understand object-oriented coding principles on a fundamental scale"
    ],
    faqs: [],
    reviews: []
  },
  "javascript": {
    images: ["/images/courses/javascript-1.webp", "/images/courses/javascript-2.webp"],
    bgDesktop: "/images/courses/javascript-cd-desktop.webp",
    bgMobile: "/images/courses/javascript-cd-mobile.webp",
    title: "JavaScript Fundamentals",
    category: "Elevare First Year Program",
    duration: "1 Month",
    mode: "Classroom Labs",
    level: "Absolute Beginner",
    tagline: "Build dynamic, script-driven interactive application logic.",
    description: "Master functions, local storage variables, network fetch calls, and modern ES6 syntax setups.",
    highlights: ["Project Development", "Practical coding challenges"],
    syllabus: [
      { phase: "Phase 1", title: "Core DOM Manipulation", desc: "Selecting page elements, custom click listeners, and dynamic styling changes." },
      { phase: "Phase 2", title: "Objects & Arrays", desc: "Advanced array sorting, array mapping, filtering data, and saving JSON." },
      { phase: "Phase 3", title: "Network APIs & Fetch", desc: "Connecting scripts to online servers, loading live data, handling responses." }
    ],
    tools: ["JavaScript", "VS Code", "Chrome console"],
    outcomes: [
      "Construct interactive widgets (to-do lists, countdown clocks, form validators)",
      "Fetch and display live data (like weather, news) from free public APIs"
    ],
    faqs: [],
    reviews: []
  },

  // JUNIOR ACADEMY
  "class-10th-subjects": {
    images: ["/images/courses/class-10th-subjects-1.webp", "/images/courses/class-10th-subjects-2.webp"],
    bgDesktop: "/images/courses/class-10th-subjects-cd-desktop.webp",
    bgMobile: "/images/courses/class-10th-subjects-cd-mobile.webp",
    title: "Class 10th Subjects",
    category: "Junior Academy",
    duration: "1 Academic Year",
    mode: "Classroom Coaching",
    level: "School Level",
    tagline: "Excel in board examinations with conceptual clarity.",
    description: "Comprehensive coaching designed for secondary board success. We focus on conceptual clarity in Mathematics and Science to build a strong future foundation.",
    highlights: ["Weekly Evaluative tests", "Board paper mocks", "Small batch sizes", "Doubt clarification hours"],
    syllabus: [
      { phase: "Term 1", title: "Mathematics Foundations", desc: "Algebra, Trigonometry patterns, Real Numbers, Coordinate Geometry foundations." },
      { phase: "Term 2", title: "Physical & Natural Sciences", desc: "Chemical reactions, Physics optics, Electricity formulas, Plant & Animal biology structures." },
      { phase: "Term 3", title: "Revision & Mock Board Exams", desc: "Solving previous board papers, time-management mocks, feedback evaluation rounds." }
    ],
    tools: ["Board Textbooks", "Conceptual worksheets", "Visual science models"],
    outcomes: [
      "Achieve deep conceptual clarity and solve math equations confidently",
      "Explain complex physics and chemistry chemical formulas with ease",
      "Write neat, highly scoring responses under mock exam conditions"
    ],
    faqs: [
      { question: "Do you cover Telugu/Hindi?", answer: "Yes, language review classes are conducted before the board exams." }
    ],
    reviews: []
  },
  "intermediate-11th-12th-mpc": {
    images: ["/images/courses/intermediate-11th-12th-mpc-1.webp", "/images/courses/intermediate-11th-12th-mpc-2.webp"],
    bgDesktop: "/images/courses/intermediate-11th-12th-mpc-cd-desktop.webp",
    bgMobile: "/images/courses/intermediate-11th-12th-mpc-cd-mobile.webp",
    title: "Intermediate MPC (Maths, Physics, Chemistry)",
    category: "Junior Academy",
    duration: "2 Years",
    mode: "Classroom Labs",
    level: "Intermediate",
    tagline: "Board excellence meets engineering entrance readiness.",
    description: "In-depth conceptual lectures covering the complete Telangana Board syllabus alongside targeted IIT-JEE and EAPCET problem-solving classes.",
    highlights: ["JEE/EAPCET Mock Test series", "Custom study materials", "Daily doubt-solving hours"],
    syllabus: [
      { phase: "Year 1", title: "Junior Intermediate Syllabus", desc: "Maths 1A & 1B (Functions, Matrices, Calculus), junior physics (Mechanics, Waves), physical/organic chemistry basics." },
      { phase: "Year 2", title: "Senior Intermediate Syllabus", desc: "Maths 2A & 2B (Probability, Complex numbers, Integrals), senior physics (Electrostatics, Optics, Magnetism), advanced organic chemistry." }
    ],
    tools: ["Vedic Maths strategies", "Formula sheets", "Daily Practice Problems (DPPs)"],
    outcomes: [
      "Master complete board calculus, coordinate algebra, and geometry layouts",
      "Apply speed-solving techniques for multiple choice entrance questions",
      "Execute lab experiments safely and score high in practical boards"
    ],
    faqs: [],
    reviews: []
  },
  "intermediate-11th-12th-bipc": {
    images: ["/images/courses/intermediate-11th-12th-bipc-1.webp", "/images/courses/intermediate-11th-12th-bipc-2.webp"],
    bgDesktop: "/images/courses/intermediate-11th-12th-bipc-cd-desktop.webp",
    bgMobile: "/images/courses/intermediate-11th-12th-bipc-cd-mobile.webp",
    title: "Intermediate BiPC (Biology, Physics, Chemistry)",
    category: "Junior Academy",
    duration: "2 Years",
    mode: "Classroom Labs",
    level: "Intermediate",
    tagline: "Detailed conceptual prep for boards and NEET exam pathways.",
    description: "Bespoke classes focusing on botany, zoology diagram pathways, and chemistry reactions combined with speed-solving biology tricks.",
    highlights: ["NEET mock papers", "Bespoke botany diagrams", "Organic chemistry drills"],
    syllabus: [
      { phase: "Year 1", title: "Junior Biology & Sciences", desc: "Plant kingdom details, animal anatomy charts, atomic structures, and kinetic physics." },
      { phase: "Year 2", title: "Senior Biology & Sciences", desc: "Genetics, plant physiology, human systems, electrochemistry, and modern physics." }
    ],
    tools: ["Visual biological model tools", "Interactive mock test portals"],
    outcomes: [
      "Label botany/zoology cellular diagrams with high precision",
      "Solve physics calculation problems relevant to medical entrances quickly"
    ],
    faqs: [],
    reviews: []
  },
  "eapcet-entrance-prep": {
    images: ["/images/courses/eapcet-entrance-prep-1.webp", "/images/courses/eapcet-entrance-prep-2.webp"],
    bgDesktop: "/images/courses/eapcet-entrance-prep-cd-desktop.webp",
    bgMobile: "/images/courses/eapcet-entrance-prep-cd-mobile.webp",
    title: "EAPCET Entrance Prep",
    category: "Junior Academy",
    duration: "Crash Course & Long Term",
    mode: "Classroom + Online Mock Tests",
    level: "Entrance Level",
    tagline: "Secure your seat in top local state universities.",
    description: "Specialized crash courses and year-long prep modules for TS/AP EAPCET engineering and agriculture streams.",
    highlights: ["Speed shortcut math", "State ranks tracking mocks", "All subject revision"],
    syllabus: [
      { phase: "Step 1", title: "Shortcut Formula Mastery", desc: "Vedic shortcuts, mathematical equations rapid solving, elimination tricks." },
      { phase: "Step 2", title: "High-Weightage Chapters Review", desc: "Prioritizing electrodynamics, organic reactions, integration, and kinematics." },
      { phase: "Step 3", title: "Daily Live Mocks", desc: "Taking previous EAPCET examinations under timed conditions." }
    ],
    tools: ["EAPCET mock question bank", "Formula charts"],
    outcomes: [
      "Solve complex quadratic and calculus operations under 60 seconds",
      "Achieve high speed accuracy on physics calculation questions"
    ],
    faqs: [],
    reviews: []
  },
  "foundation-programs": {
    images: ["/images/courses/foundation-programs-1.webp", "/images/courses/foundation-programs-2.webp"],
    bgDesktop: "/images/courses/foundation-programs-cd-desktop.webp",
    bgMobile: "/images/courses/foundation-programs-cd-mobile.webp",
    title: "Foundation Programs (Class 8th & 9th)",
    category: "Junior Academy",
    duration: "1 Academic Year",
    mode: "Classroom",
    level: "Foundational Schooling",
    tagline: "Build competitive logic early.",
    description: "Introducing young school minds to high-level logical reasoning, advanced algebra, and chemistry/physics conceptual frameworks to prepare them for JEE/NEET classes.",
    highlights: ["Logical puzzles", "Scientific experiment cases", "Conceptual tests"],
    syllabus: [
      { phase: "Term 1", title: "Analytical Mathematics", desc: "Logical number puzzles, equations, geometry, rational fractions." },
      { phase: "Term 2", title: "Everyday Physics & Chemistry", desc: "Force metrics, atomic structures, basic acids and bases experiments." }
    ],
    tools: ["Logical reasoning worksheets", "Scientific experiment kits"],
    outcomes: [
      "Solve logical reasoning puzzles and mathematical equations quickly",
      "Understand the scientific method behind everyday physical events"
    ],
    faqs: [],
    reviews: []
  },
  "neet-entrance-prep": {
    images: ["/images/courses/neet-entrance-prep-1.webp", "/images/courses/neet-entrance-prep-2.webp"],
    bgDesktop: "/images/courses/neet-entrance-prep-cd-desktop.webp",
    bgMobile: "/images/courses/neet-entrance-prep-cd-mobile.webp",
    title: "NEET Entrance Prep",
    category: "Junior Academy",
    duration: "1 Academic Year / Crash Course",
    mode: "Classroom Coaching + Test Series",
    level: "Medical Entrance Level",
    tagline: "Rigorous coaching and test series tailored specifically for medical (BiPC) aspirants.",
    description: "Tailored exclusively for BiPC students, our NEET preparation program provides exhaustive coverage of Botany, Zoology, Physics, and Chemistry. Driven by weekly mock examinations, custom biology diagram drills, and experienced medical entrance faculty, we ensure you build the conceptual speed and precision required to secure top ranks.",
    highlights: ["Specifically for BiPC Students", "Weekly NEET Pattern Mock Tests", "Exhaustive Diagram & Reaction Drills", "Experienced Medical Coaching Faculty"],
    syllabus: [
      { phase: "Phase 1", title: "Advanced Biology (Botany & Zoology)", desc: "Deep dive into Plant Physiology, Diversity in Living World, Cell Structure and Division, Genetics, Evolution, and Human Physiology with focus on NCERT nomenclature." },
      { phase: "Phase 2", title: "NEET-Pattern Physics Core", desc: "Building strong foundations and speed tricks in Mechanics, Thermodynamics, Electrodynamics, Optics, and Modern Physics tailored for medical aspirants." },
      { phase: "Phase 3", title: "Essential Medical Chemistry", desc: "Comprehensive training in Organic reaction mechanisms, Chemical Bonding, Coordination Chemistry, and Physical Chemistry calculation shortcuts." },
      { phase: "Phase 4", title: "All India Level Test Series", desc: "Rigorous full-length NEET pattern mock tests, negative marking strategies, and interactive question-by-question doubt clearance sessions." }
    ],
    tools: ["NCERT Exemplar Solutions", "Interactive Biology Charts", "Daily Practice Problems (DPPs)", "Online NEET Test Portal"],
    outcomes: [
      "Master high-weightage topics in Botany and Zoology to score maximum marks in Biology",
      "Develop rapid calculation and estimation skills for Physics and Chemistry MCQs",
      "Minimize negative marking errors through structured mock test strategies",
      "Build confidence to secure MBBS/BDS admissions in top medical colleges"
    ],
    faqs: [
      { question: "Is this program open to MPC students?", answer: "No, this NEET program is tailored specifically for Biology, Physics, and Chemistry (BiPC) medical stream students." },
      { question: "How often are the NEET mock tests conducted?", answer: "Mock tests are conducted weekly, transition to bi-weekly, and eventually daily during the final crash course phase." }
    ],
    reviews: []
  },

  // BUSINESS LAB SERVICES
  "business-planning": {
    images: ["/images/courses/business-planning-1.webp", "/images/courses/business-planning-2.webp"],
    bgDesktop: "/images/courses/business-planning-cd-desktop.webp",
    bgMobile: "/images/courses/business-planning-cd-mobile.webp",
    title: "Business Planning",
    category: "Business Lab",
    duration: "2 Months",
    mode: "Consulting / Incubation Labs",
    level: "Founder Level",
    tagline: "Architect strategic viability roadmaps for your startup ideas.",
    description: "Go from abstract idea to pitch-ready startup model. Learn market feasibility metrics, competitive landscape evaluations, and financial cashflow projection structures.",
    highlights: ["Interactive business canvas", "GTM templates", "1-on-1 advisor reviews"],
    syllabus: [
      { phase: "Phase 1", title: "Value Proposition Canvas", desc: "Refining core client problem statements, solution parameters, and value models." },
      { phase: "Phase 2", title: "Market Feasibility Metrics", desc: "Analyzing Total Addressable Market (TAM), SAM, SOM segments and competitor matrices." },
      { phase: "Phase 3", title: "Financial Forecast Excel", desc: "Projecting cashflows, client acquisition costs (CAC), lifetime values (LTV), break-even markers." }
    ],
    tools: ["Lean Canvas", "Financial spreadsheet generators", "Competitive templates"],
    outcomes: [
      "Draft a professional multi-page business roadmap paper for stakeholders",
      "Formulate custom product price structures based on detailed cost analysis"
    ],
    faqs: [],
    reviews: []
  },
  "market-analysis": {
    images: ["/images/courses/market-analysis-1.webp", "/images/courses/market-analysis-2.webp"],
    bgDesktop: "/images/courses/market-analysis-cd-desktop.webp",
    bgMobile: "/images/courses/market-analysis-cd-mobile.webp",
    title: "Market Analysis",
    category: "Business Lab",
    duration: "1 Month",
    mode: "Advisory / Project work",
    level: "Startup Level",
    tagline: "Discover product-market fit parameters with data.",
    description: "Design consumer survey panels, evaluate target buyer segments, and locate competitive advantage spaces.",
    highlights: ["Target buyer metrics", "Competitor matrix build"],
    syllabus: [
      { phase: "Phase 1", title: "Target Persona Modeling", desc: "Drafting detailed demographic, psychographic, and buying habit profiles." },
      { phase: "Phase 2", title: "Competitor Intelligence", desc: "Evaluating market leaders' feature offerings, gaps, pricing models." }
    ],
    tools: ["Google Forms", "Audience analyzer sheets", "SWOT matrices"],
    outcomes: [
      "Build detailed customer persona profiles that drive advertising",
      "Produce a competitive gap analysis chart identifying blue ocean features"
    ],
    faqs: [],
    reviews: []
  },
  "leadership": {
    images: ["/images/courses/leadership-1.webp", "/images/courses/leadership-2.webp"],
    bgDesktop: "/images/courses/leadership-cd-desktop.webp",
    bgMobile: "/images/courses/leadership-cd-mobile.webp",
    title: "Leadership & Team Operations",
    category: "Business Lab",
    duration: "2 Months",
    mode: "Workshops / Advisory",
    level: "Management Level",
    tagline: "Build high-performing collaborative work environments.",
    description: "Learn delegating frameworks, project task tracking pipelines, team communication protocols, and scaling operations.",
    highlights: ["Project management setup", "Team communication frameworks"],
    syllabus: [
      { phase: "Phase 1", title: "Operational Pipelines", desc: "Setting up task tracking boards, workflows, responsibility matrix rules." },
      { phase: "Phase 2", title: "Conflict & Alignment", desc: "Conducting team meetings, goal tracking (OKRs), and feedback systems." }
    ],
    tools: ["Trello", "Asana", "Slack structures", "OKR checklists"],
    outcomes: [
      "Design clear team task tracking boards using modern project tools",
      "Formulate operational guidelines that reduce workspace project delays"
    ],
    faqs: [],
    reviews: []
  },
  "venture-capital": {
    images: ["/images/courses/venture-capital-1.webp", "/images/courses/venture-capital-2.webp"],
    bgDesktop: "/images/courses/venture-capital-cd-desktop.webp",
    bgMobile: "/images/courses/venture-capital-cd-mobile.webp",
    title: "Venture Capital & Pitch Deck Prep",
    category: "Business Lab",
    duration: "2 Months",
    mode: "Consulting",
    level: "Founder Level",
    tagline: "Prepare your company to raise angel and seed rounds.",
    description: "Learn cap-table dynamics, valuation methodologies, pitch deck slide creation, and how to talk to investment networks.",
    highlights: ["Pitch deck slide audit", "Cap-table templates", "Mock pitch reviews"],
    syllabus: [
      { phase: "Phase 1", title: "Cap-table & Valuation Dynamics", desc: "Calculating equity dilution, angel investment parameters, convertible note rules." },
      { phase: "Phase 2", title: "Pitch Deck Design", desc: "Drafting problem, solution, market size, business model, team slides." },
      { phase: "Phase 3", title: "Mock Pitch Panels", desc: "Presenting to simulated angel advisors, handling tough financial questions." }
    ],
    tools: ["Valuation calculators", "Slide deck frameworks", "Investor tracker lists"],
    outcomes: [
      "Build a clean 10-slide startup investor pitch deck template",
      "Calculate cap-table dilution parameters accurately across seed rounds"
    ],
    faqs: [],
    reviews: []
  },
  "digital-marketing": {
    images: ["/images/courses/digital-marketing-1.webp", "/images/courses/digital-marketing-2.webp"],
    bgDesktop: "/images/courses/digital-marketing-cd-desktop.webp",
    bgMobile: "/images/courses/digital-marketing-cd-mobile.webp",
    title: "Digital Marketing Strategy",
    category: "Business Lab",
    duration: "2 Months",
    mode: "Consulting",
    level: "Startup Level",
    tagline: "Drive user acquisition channels with targeted campaign logic.",
    description: "SEO tracking parameters, Google Search Console setups, ad campaign budget planning, and landing page conversion analysis.",
    highlights: ["Google Analytics setup", "SEO audit cases", "Ad target models"],
    syllabus: [
      { phase: "Phase 1", title: "Search Engine Optimization (SEO)", desc: "Keyword mapping, on-page tags, meta content optimization, search indexing." },
      { phase: "Phase 2", title: "Paid Acquisition (Ads)", desc: "Designing Facebook/Google target profiles, ad copywriting, cost-per-click calculation." }
    ],
    tools: ["Google Analytics", "GSC", "Ahrefs indicators", "Ad planners"],
    outcomes: [
      "Formulate search index strategies that rank articles on Google search grids",
      "Design ad campaign parameters targeting high-intent prospective buyers"
    ],
    faqs: [],
    reviews: []
  },
  "website-web-app-development-for-startups": {
    images: ["/images/courses/website-web-app-development-for-startups-1.webp", "/images/courses/website-web-app-development-for-startups-2.webp"],
    bgDesktop: "/images/courses/website-web-app-development-for-startups-cd-desktop.webp",
    bgMobile: "/images/courses/website-web-app-development-for-startups-cd-mobile.webp",
    title: "Startup Web App Development",
    category: "Business Lab",
    duration: "3 Months",
    mode: "Consulting + Custom Coding",
    level: "Founder Level",
    tagline: "Launch your custom high-performance startup website.",
    description: "Launch your business online with custom responsive layouts, payment gateway setups, database backends, and speed optimization.",
    highlights: ["Live launch roadmap", "Payment configs", "CMS setup guides"],
    syllabus: [
      { phase: "Phase 1", title: "Design mockup audits", desc: "Reviewing wireframes, UI graphics, responsive device grids specifications." },
      { phase: "Phase 2", title: "Core Landing & Coding", desc: "Responsive coding layouts, landing page speed scoring, SEO semantic tag integrations." },
      { phase: "Phase 3", title: "Integration & Live", desc: "Setting up contact forms, stripe/razorpay checkout buttons, domain server setups." }
    ],
    tools: ["React", "Tailwind CSS", "Stripe API", "Node.js", "Analytics APIs"],
    outcomes: [
      "Deploy custom high-performance corporate landing pages online",
      "Integrate automated email forms and checkout systems seamlessly"
    ],
    faqs: [],
    reviews: []
  },
  "mobile-app-development": {
    images: ["/images/courses/mobile-app-development-1.webp", "/images/courses/mobile-app-development-2.webp"],
    bgDesktop: "/images/courses/mobile-app-development-cd-desktop.webp",
    bgMobile: "/images/courses/mobile-app-development-cd-mobile.webp",
    title: "Mobile App Development for Startups",
    category: "Business Lab",
    duration: "3 Months",
    mode: "Consulting + Custom Coding",
    level: "Founder Level",
    tagline: "Launch cross-platform iOS & Android mobile services.",
    description: "Get assistance building React Native apps, custom authentication models, push notification APIs, and App Store guidelines.",
    highlights: ["Cross-platform testing", "Store deployment guides"],
    syllabus: [
      { phase: "Phase 1", title: "Cross-platform Setup", desc: "React Native foundations, mobile navigation routes, state configurations." },
      { phase: "Phase 2", title: "Features & Push Notify", desc: "Device authentication tokens, push notifications, storage operations." },
      { phase: "Phase 3", title: "Store Submissions", desc: "App store submission steps, Google Play consoles, listing updates." }
    ],
    tools: ["React Native", "Expo", "Firebase", "App Store Connect", "Play Console"],
    outcomes: [
      "Compile and test native iOS and Android application binaries on devices",
      "Configure cloud authentication protocols and push notify alerts"
    ],
    faqs: [],
    reviews: []
  }
};
